module.exports = __webpack_public_path__ + "assets/img/d31c14118b40fdfa9ef08940584ce8a6.png";